<template>
  <div class="theme-layout">
    <header class="header2">
      <div class="topbar">
        <div class="container">
          <div class="header-timer">
            <p>Each 1 Bring 1 event</p>
            <ul class="headercounter">
              <li>
                <span class="days">00</span>
                <p class="days_ref">DAYS</p>
              </li>
              <li>
                <span class="hours">00</span>
                <p class="hours_ref">HOURS</p>
              </li>
              <li>
                <span class="minutes">00</span>
                <p class="minutes_ref">MINTS</p>
              </li>
              <li>
                <span class="seconds">00</span>
                <p class="seconds_ref">SECS</p>
              </li>
            </ul>
          </div>
          <p><i class="fa fa-mobile"></i> Mobile: (514) 701-7377</p>
          <!--- CONTACT -->
          <p><i class="fa fa-envelope"></i> office@rightwayupc.ca</p>
          <!--- EMAIL -->
          <ul class="social-media">
            <li>
              <a
                title="RIGHTWAY PENTECOSTAL CHURCH Facebook"
                href="https://www.facebook.com/rightwaypentecostal"
                target="_blank"
              >
                <i class="fa fa-facebook"></i>
              </a>
            </li>
            <li>
              <a title href="javascript:void(0);">
                <i class="fa fa-twitter"></i>
              </a>
            </li>
            <li>
              <a title href="javascript:void(0);">
                <i class="fa fa-linkedin"></i>
              </a>
            </li>
            <li>
              <a title href="javascript:void(0);">
                <i class="fa fa-google-plus"></i>
              </a>
            </li>
          </ul>
          <div @click="redirectToShop" class="cart-dropdown">
            <p>
              <i class="fa fa-shopping-cart"></i>
              {{ basketCount }} item(s) -
              <span>$ {{ basketTotal }}</span>
            </p>
          </div>
        </div>
      </div>
      <!--- TOP BAR -->
      <nav class="style1">
        <div class="container">
          <div class="logo">
            <router-link to="/" :exact="true">
              <img
                src="/dist/assets/logos/rupc_main_logo_hr_001.png"
                alt="RIGHTWAY PENTECOSTAL CHURCH LOGO"
              />
            </router-link>
          </div>
          <!--- LOGO -->
          <ul>
            <li
              v-if="isCoventryAdmin || isLeicesterAdmin"
              class="menu-item-has-children"
            >
              <a href="javascript:void(0);" title>Admin</a>
              <ul>
                <li v-if="isCoventryAdmin" class="menu-item-has-children">
                  <a href="javascript:void(0);" title>RUPC-Montreal</a>
                  <ul>
                    <li>
                      <router-link to="/shop-products-admin"
                        >Cash Orders</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/montreal-resources"
                        >Manage Products</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/montreal-people"
                        >Manage People</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/montreal-events"
                        >Manage Events</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/montreal-addresses"
                        >Manage Addresses</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/montreal-alerts"
                        >Information Alert</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/donation-admin"
                        >Manage Donation Info</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li v-if="isLeicesterAdmin" class="menu-item-has-children">
                  <a href="javascript:void(0);" title>Leicester</a>
                  <ul>
                    <li>
                      <router-link to="/toronto-resources"
                        >Manage Products</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/toronto-people"
                        >Manage People</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/toronto-events"
                        >Manage Events</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/toronto-addresses"
                        >Manage Addresses</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/toronto-alerts"
                        >Information Alert</router-link
                      >
                    </li>
                  </ul>
                </li>
                <!--<li><a href="javascript:void(0);" title="CMI Birmingham">Birmingham</a></li>-->
              </ul>
            </li>
            <li>
              <router-link to="/" :exact="true">Home</router-link>
            </li>
            <li>
              <router-link to="/about">About us</router-link>
            </li>
            <li>
              <router-link to="/shop-products">Audio</router-link>
            </li>
            <li>
              <router-link to="/donate">Donate</router-link>
            </li>
            <li>
              <a href="#contact">Contact</a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <!--- HEADER -->
    <div class="responsive-header">
      <div class="responsive-prayer">
        <p>Each 1 Bring 1 event</p>
        <ul class="headercounter">
          <li>
            <span class="days">00</span>
            <p class="days_ref">DAYS</p>
          </li>
          <li>
            <span class="hours">00</span>
            <p class="hours_ref">HOURS</p>
          </li>
          <li>
            <span class="minutes">00</span>
            <p class="minutes_ref">MINTS</p>
          </li>
          <li>
            <span class="seconds">00</span>
            <p class="seconds_ref">SECS</p>
          </li>
        </ul>
      </div>
      <!-- Responsive Prayer -->
      <div class="responsive-contact">
        <span>
          <p class="responsive-phone">
            <i class="fa fa-phone"></i> Mobile: (514) 701-7377
          </p>
          <p class="responsive-mail">
            <i class="fa fa-envelope"></i> office@rightwayupc.ca
          </p>
        </span>
        <a class="phone-btn active" href="#" title>
          <i class="fa fa-phone"></i>
        </a>
        <a class="mail-btn" href="#" title>
          <i class="fa fa-envelope"></i>
        </a>
      </div>
      <!-- Responsive Contact -->
      <div class="responsive-extras">
        <div class="responsive-social">
          <a
            title="RIGHTWAY PENTECOSTAL CHURCH Facebook page"
            href="https://www.facebook.com/rightwaypentecostal"
            target="_blank"
          >
            <i class="fa fa-facebook"></i>
          </a>
          <a href="javascript:void(0);" title>
            <i class="fa fa-twitter"></i>
          </a>
          <a href="javascript:void(0);" title>
            <i class="fa fa-google-plus"></i>
          </a>
          <a href="javascript:void(0);" title>
            <i class="fa fa-linkedin"></i>
          </a>
        </div>
        <!-- Responsive Social -->
        <div @click="redirectToShop" class="responsive-cart">
          <i class="fa fa-shopping-cart"></i>
          {{ basketCount }} item(s) -
          <span>$ {{ basketTotal }}</span>
        </div>
      </div>
      <!-- Responsive Extras -->
      <div class="responisve-bar">
        <div class="responsive-logo">
          <router-link to="/" :exact="true">
            <img
              src="/dist/assets/logos/rupc_main_logo_small_001.png"
              alt="RIGHTWAY PENTECOSTAL CHURCH LOGO"
            />
          </router-link>
        </div>
        <span class="responsive-btn">
          <i class="fa fa-list"></i>
        </span>
      </div>
    </div>
    <!-- Responsive Header -->
    <div class="responsive-menu">
      <ul>
        <li
          v-if="isCoventryAdmin || isLeicesterAdmin"
          class="menu-item-has-children"
        >
          <a href="javascript:void(0);" title>Admin</a>
          <ul>
            <li v-if="isCoventryAdmin" class="menu-item-has-children">
              <a href="javascript:void(0);" title>RUPC-Montreal</a>
              <ul>
                <li>
                  <router-link to="/shop-products-admin"
                    >Cash Orders</router-link
                  >
                </li>
                <li>
                  <router-link to="/montreal-resources"
                    >Manage Products</router-link
                  >
                </li>
                <li>
                  <router-link to="/montreal-people">Manage People</router-link>
                </li>
                <li>
                  <router-link to="/montreal-events">Manage Events</router-link>
                </li>
                <li>
                  <router-link to="/montreal-addresses"
                    >Manage Addresses</router-link
                  >
                </li>
                <li>
                  <router-link to="/montreal-alerts"
                    >Information Alert</router-link
                  >
                </li>
                <li>
                  <router-link to="/donation-admin"
                    >Manage Donation Info</router-link
                  >
                </li>
              </ul>
            </li>
            <li v-if="isLeicesterAdmin" class="menu-item-has-children">
              <a href="javascript:void(0);" title>Toronto</a>
              <ul>
                <li>
                  <router-link to="/toronto-resources"
                    >Manage Products</router-link
                  >
                </li>
                <li>
                  <router-link to="/toronto-people">Manage People</router-link>
                </li>
                <li>
                  <router-link to="/toronto-events">Manage Events</router-link>
                </li>
                <li>
                  <router-link to="/toronto-addresses"
                    >Manage Addresses</router-link
                  >
                </li>
                <li>
                  <router-link to="/toronto-alerts"
                    >Information Alert</router-link
                  >
                </li>
              </ul>
            </li>
            <!--<li><a href="javascript:void(0);" title="CMI Birmingham">Birmingham</a></li>-->
          </ul>
        </li>
        <li>
          <router-link to="/" :exact="true">Home</router-link>
        </li>
        <li>
          <router-link to="/about">About us</router-link>
        </li>
        <li>
          <router-link to="/shop-products">Audio</router-link>
        </li>
        <li>
          <router-link to="/donate">Donate</router-link>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
    </div>
    <!-- Responsive Menu -->
    <router-view></router-view>

    <div class="bottom-footer">
      <div class="container">
        <p class="cmi-dev-contact">
          For your software needs contact
          <span style="color:#B6B9BF">programmer@softmighty.com</span> :
          mobile-apps, web-apps, websites, data-driven apps, consultancy and IT
          Strategy advisory services.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "App",
  data() {
    return {};
  },
  methods: {
    ...mapActions(["handleAuthenticationRedirect"]),
    redirectToShop: function() {
      if (this.$route.name != "shop-products") {
        this.$router.push("/shop-products");
      }
    },
    getCountDownDate: function() {
      var dayOfWeek = 6;
      var day = 31;
      while (
        new Date(
          "08/" + day + "/" + new Date().getFullYear().toString()
        ).getDay() != dayOfWeek
      ) {
        day--;
      }

      if (
        new Date() <
        new Date("08/" + day + "/" + new Date().getFullYear().toString())
      ) {
        return "08/" + day + "/" + new Date().getFullYear().toString();
      } else if (
        new Date() >
        new Date("09/" + "01/" + new Date().getFullYear().toString())
      ) {
        day = 31;
        while (
          new Date(
            "08/" +
              day +
              "/" +
              parseInt(new Date().getFullYear() + 1).toString()
          ).getDay() != dayOfWeek
        ) {
          day--;
        }
        return (
          "08/" + day + "/" + parseInt(new Date().getFullYear() + 1).toString()
        );
      } else {
        return "01/01/2020 12:00:00";
      }
    },
    setCountDownDate: function() {
      window.$(".headercounter").downCount({
        date: this.getCountDownDate(),
        offset: -1
      });
    }
  },
  computed: {
    ...mapGetters([
      "isCoventryAdmin",
      "isLeicesterAdmin",
      "basketCount",
      "basketTotal"
    ])
  },
  mounted() {
    this.setCountDownDate();
    // Redirect: once login is successful and redirects with tokens, call Graph API
    this.$msalInstance
      .handleRedirectPromise()
      .then(response => {
        // console.log("Hello 1");
        // console.log(response);
        this.handleAuthenticationRedirect({ vm: this, response });
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>
